import { useConsents } from "@cs_teamwaydev/mailvista-sdk_react";
import { useMutation } from "@tanstack/react-query";

interface CheckConsentParams {
    didomiUserProfile: any;
    didomiShouldCollect: boolean;
}

const useCheckConsent = () => {
    const consents = useConsents();

    const checkConsent = useMutation<boolean, Error, CheckConsentParams>({
        mutationKey: ["checkConsent"],
        mutationFn: async ({
            didomiUserProfile,
            didomiShouldCollect,
        }: CheckConsentParams): Promise<boolean> => {
            try {
                if (!consents) {
                    throw new Error("Consents are not available yet");
                }

                const hasAllRequiredConsents =
                    await consents.hasAllRequiredConsents(
                        didomiUserProfile,
                        didomiShouldCollect,
                    );

                return hasAllRequiredConsents;
            } catch (error) {
                console.error("Error syncing consent:", error);
                throw error;
            }
        },
    });

    return checkConsent;
};

export default useCheckConsent;
